// pages/FormViewerPage/hooks/useFormViewer/effectsEverpro.ts — status agregator.
// Diekstrak dari effectsCore (file ≤100) + gate fase 2: status kurir bukan
// konten kritis; tarif terbaik tetap dihitung ulang saat tiba (revalidasi diam).
// Mencakup Everpro + Mengantar + Lincah (aturan user 2026-10-17 + 2026-10-20:
// brand dengan Mengantar/Lincah saja tetap dapat daftar tarif — pool digabung
// di fetchMergedRates).
// PENTING: pakai `ready` boolean (bukan angka phase) di deps — kalau angka,
// cleanup saat fase 2→3 membatalkan hasil fetch status yang lambat → kurir
// tak muncul (insiden 2026-10-10). Boolean flip sekali → tak ada cleanup palsu.
import { useEffect, useRef } from 'react';
import { fetchBrandEverproStatus } from '../../../../services/everproAPI';
import { fetchBrandMengantarStatus } from '../../../../services/mengantar/status';
import { fetchBrandLincahStatus } from '../../../../services/lincah/status';
import type { LoadPhase } from '../../../../utils/stagedLoad';
import type { FormViewerState } from './state';

export function useFormViewerEverproEffects(s: FormViewerState, phase: LoadPhase) {
    const { form, setBrandEverpro, setBrandMengantar, setBrandLincah } = s as any;
    const doneFor = useRef<string | null>(null);
    const ready = phase >= 2;
    useEffect(() => {
        if (!ready) return;
        if (!form?.brandId) { setBrandEverpro({ configured: false }); setBrandMengantar({ configured: false }); setBrandLincah({ configured: false }); return; }
        if (doneFor.current === form.brandId) return;
        doneFor.current = form.brandId;
        let cancelled = false;
        fetchBrandEverproStatus(form.brandId).then(status => {
            if (!cancelled) setBrandEverpro(status);
        });
        fetchBrandMengantarStatus(form.brandId).then(status => {
            if (!cancelled) setBrandMengantar(status);
        });
        fetchBrandLincahStatus(form.brandId).then(status => {
            if (!cancelled) setBrandLincah(status);
        });
        return () => { cancelled = true; };
    }, [form?.brandId, setBrandEverpro, setBrandMengantar, setBrandLincah, ready]);
}
